import IDebitCardDetails from '../models/IDebitCardDetails';

export const validateDebitCardDetails = (debitCardDetails: IDebitCardDetails) => {
  if (!debitCardDetails.cardNumber || debitCardDetails.cardNumber.length < 14 ||
      !debitCardDetails.cvv || debitCardDetails.cvv.length < 3) {
    return false;
  }

  if (debitCardDetails.hasName) {
    if (!debitCardDetails.firstName || !debitCardDetails.lastName) {
      return false;
    }
  }

  return validateExpirationDate(debitCardDetails.expirationMonth, debitCardDetails.expirationYear);
}

export const validateExpirationDate = (expirationMonth: string, expirationYear: string) => {
  if (!expirationMonth || !expirationYear || expirationMonth.length !== 2 || expirationYear.length !== 2) {
    return false;
  }
  if (Number(expirationMonth) > 12) {
    return false;
  }
  const d = new Date();

  const currentDateString = `${d.getFullYear().toString().substr(-2)}/${('0' + (d.getMonth() + 1)).substr(-2)}`;
  const expirationString = `${expirationYear}/${expirationMonth}`;
  if (expirationString < currentDateString) {
    return false;
  }

  return true;
}
